// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullAdminRegatta,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  FormSection,
} from '@vroskus/library-components';

// Helpers
import {
  cleanFormValues,
  isDiff,
} from '@vroskus/library-helpers/dist/browser';
import {
  defaultUpsertItem,
} from '../../../../helpers';

// Components
import RegattaRegistrationFields from '../../../fields/RegattaRegistrationFields';

// Services
import Services from '../../../../services';

// Types
type $Props = $Translate & {
  id: string;
  item: $FullAdminRegatta;
};

type $State = {
  changed: boolean;
  item: $FullAdminRegatta;
};

class RegattaRegistrationSectionView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      changed: false,
      item: props.item,
    };
  }

  componentDidUpdate(prevProps: $Props): void {
    const {
      item,
    } = this.props;

    if (isDiff(
      prevProps.item,
      item,
    )) {
      this.setState({
        item,
      });
    }
  }

  render() {
    const {
      id,
      item: initialItem,
      t,
    } = this.props;
    const {
      changed,
      item,
    } = this.state;

    return (
      <FormSection
        changed={changed}
        fields={(
          <RegattaRegistrationFields
            item={item}
            onChange={() => this.setState({
              changed: true,
            })}
          />
        )}
        headerDescription={t('Regatta registration form settings')}
        headerIconClass={'icon-plus'}
        headerTitle={t('Regatta registration')}
        id={id}
        labelClearButton={t('Clear')}
        labelSaveButton={t('Save')}
        onAction={(value) => defaultUpsertItem({
          action: async () => {
            const params = cleanFormValues<$FullAdminRegatta>({
              ...item,
              ...value,
            });

            await Services.Api.updateRegatta(params);

            this.setState({
              changed: false,
            });
          },
        })}
        onClear={() => this.setState({
          changed: false,
          item: initialItem,
        })}
      />
    );
  }
}

export default RegattaRegistrationSectionView;
